import { Base } from './Base';

const classes = {
  showForm: 'show-form'
};

export class InlineAddToCartTrigger extends Base {
  constructor(behaviorName, element) {
    super(behaviorName, element);
    this.init();
  }

  init() {
    this.bindClickListener();
  }

  bindClickListener() {
    this.element.addEventListener('click', () => {
      this.handleClick();
    });
  }

  handleClick() {
    document.getElementById(this.element.dataset.target).classList.add(classes.showForm);
  }
}